module.exports = __webpack_public_path__ + "Lato-Italic.4eb103b4d12be57cb1d0.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Italic.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Italic.woff2
// module chunks = styles